export type SlideViewMode = 'thumbnails' | 'names'

export const SLIDE_VIEW_STORAGE_KEY = 'indico:slide-panel-view'

export const readSlideViewMode = (
  storage?: Pick<Storage, 'getItem'> | null
): SlideViewMode => {
  try {
    return storage?.getItem(SLIDE_VIEW_STORAGE_KEY) === 'names' ? 'names' : 'thumbnails'
  } catch {
    return 'thumbnails'
  }
}

export const writeSlideViewMode = (
  storage: Pick<Storage, 'setItem'> | null | undefined,
  mode: SlideViewMode
) => {
  try {
    storage?.setItem(SLIDE_VIEW_STORAGE_KEY, mode)
  } catch {
    return
  }
}

export const getSlideLabel = (
  description: string | undefined,
  index: number,
  slideNumber: (number: number) => string
) => description?.trim() || slideNumber(index + 1)
